module.exports = __webpack_public_path__ + "img/avatar.7a21cbe9.svg";